import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { pricingData } from '@/data/mock';
import { Check } from 'lucide-react';

export const PricingSection = ({ onBookDemo }) => {
  return (
    <section id="pricing" className="relative py-24 bg-slate-950">
      <div className="absolute inset-0">
        <div className="absolute bottom-0 left-1/4 w-[600px] h-[400px] bg-indigo-500/5 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-indigo-500/10 text-indigo-400 text-sm font-medium rounded-full mb-4">
            Pricing
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Plans that scale with you
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Start small and grow as your hiring needs expand
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {pricingData.map((plan, index) => (
            <Card
              key={index}
              className="relative overflow-hidden bg-slate-900/50 border-slate-800/50 transition-all duration-300 hover:scale-105"
            >
              
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-white mb-2">{plan.tier}</h3>
                <p className="text-slate-400 mb-6">{plan.tagline}</p>
                
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-3">
                      <Check size={18} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                      <span className="text-slate-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Button
                  onClick={onBookDemo}
                  className="w-full bg-slate-800 hover:bg-slate-700 text-white border border-slate-700"
                >
                  {plan.cta}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
